// extracted by mini-css-extract-plugin
export var success = "style-module--success--1-QFn";
export var success_suptitle = "style-module--success_suptitle--2DBv3";
export var success_title = "style-module--success_title--2yy4g";